import { useInfiniteQuery } from '@tanstack/react-query'
import { minutesToMillis } from 'helpers'
import { QueryKeys } from '../../key-registry'
import { toNewsPost } from '../models/mapper'
import { NewsPost } from '../models/types'
import { fetchNewsPostsPageV1 } from './http'

export const NEWS_PAGE_SIZE = 10

export interface NewsPostsPage {
  posts: NewsPost[]
  last: boolean
}

export async function fetchNewsPosts(page: number, opts?: { signal?: AbortSignal }): Promise<NewsPostsPage> {
  const response = await fetchNewsPostsPageV1({ page, size: NEWS_PAGE_SIZE }, opts)

  return {
    posts: response.content.map(toNewsPost),
    last: response.last,
  }
}

export function useNewsPostsQuery(enabled: boolean) {
  return useInfiniteQuery({
    queryKey: QueryKeys.news.feed(),
    queryFn: ({ pageParam = 0, signal }) => fetchNewsPosts(pageParam, { signal }),
    getNextPageParam: (lastPage, pages) => (lastPage.last ? undefined : pages.length),
    enabled,
    staleTime: minutesToMillis(1),
    refetchOnWindowFocus: false,
  })
}
